import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { TaskDetailsType } from '@/types/dashboardTypes';

export const getTaskApi = (id: string): Promise<ApiResponseType<TaskDetailsType>> => {
  return authApiService.GET(`/dashboard/tasks/${id}/`);
};
